import { bootToolPage } from '../lib/boot-tool'
import { t } from '../i18n/dictionaries'
import { resolveDefaultLocale, getFollowSystem, setFollowSystem, setLocale } from '../lib/locale'
import { getThemeMode, setThemeMode, type ThemeMode } from '../lib/theme'
import { SUPPORTED_LOCALES, type Locale } from '../site'

const locale = bootToolPage('settings')

const lang = document.querySelector('[data-settings-lang]')
const theme = document.querySelector('[data-settings-theme]')
if (lang) {
  lang.textContent = getFollowSystem()
    ? `${t(locale, 'follow_system')} · ${resolveDefaultLocale()}`
    : resolveDefaultLocale()
}
if (theme) {
  const mode = getThemeMode()
  theme.textContent = t(locale, mode)
}

document.querySelectorAll<HTMLButtonElement>('[data-settings-locale]').forEach((button) => {
  const value = button.dataset.settingsLocale
  const active = value === 'follow' ? getFollowSystem() : !getFollowSystem() && value === resolveDefaultLocale()
  button.classList.toggle('is-active', active)
  button.addEventListener('click', () => {
    if (value === 'follow') setFollowSystem(true)
    else if (SUPPORTED_LOCALES.includes(value as Locale)) setLocale(value as Locale)
    location.reload()
  })
})

document.querySelectorAll<HTMLButtonElement>('[data-settings-theme-mode]').forEach((button) => {
  const value = button.dataset.settingsThemeMode as ThemeMode
  button.classList.toggle('is-active', value === getThemeMode())
  button.addEventListener('click', () => {
    setThemeMode(value)
    document.querySelectorAll('[data-settings-theme-mode]').forEach((node) => node.classList.remove('is-active'))
    button.classList.add('is-active')
    if (theme) theme.textContent = t(locale, value)
  })
})

document.querySelector('[data-action="clear-local"]')?.addEventListener('click', () => {
  ;['sd.locale', 'sd.localeFollowSystem', 'sd.theme', 'sd.wizard', 'sd.report'].forEach((key) =>
    localStorage.removeItem(key),
  )
  location.reload()
})
